import { Observable } from 'rxjs';

/** got from https://blog.josequinto.com/2017/03/09
 * /typescript-functions-to-get-current-domain-site-collection
 * -and-site-urls-with-window-location-fallback/ */
// @dynamic
export class Utils {
  /*
   * Function to get Site Collection URL
   * Samples:
   *      'https://domain.sharepoint.com/sites/intranet'
   */
  public static getSiteCollectionUrl(prod: string): string {
    const mainJsScript = this.getMainScriptTag(prod);
    if (mainJsScript) {
      let siteCollUrl: string = (<any>mainJsScript).src.toLowerCase().replace(`/siteassets/spxrpp/${prod.toLowerCase()}/main.js`, '');
      if (siteCollUrl.toLowerCase().indexOf('?ctag') >= 0) {
        siteCollUrl = siteCollUrl.substr(0, siteCollUrl.toLowerCase().indexOf('?ctag'));
      }
      if (siteCollUrl === '') {
        siteCollUrl = '/';
      }
      return siteCollUrl;
    }
    return null;
  }


  private static getMainScriptTag(prod) {
    const scripts = document.querySelectorAll('script');
    for (let i = 0; i < scripts.length; i++) {
      const item = scripts[i];
      if (item.src.toLowerCase().indexOf(`/siteassets/spxrpp/${prod.toLowerCase()}/main.js`) > -1) {
        return item;
      }
    }
    return null;
  }
  /*
   * Function to get Current Site Url
   * Samples:
   *      'https://domain.sharepoint.com/sites/intranet/subsite/Pages/Home.aspx'
   */
  public static getCurrentAbsoluteSiteUrl(): string {
    if (window
        && 'location' in window
        && 'protocol' in window.location
        && 'pathname' in window.location
        && 'host' in window.location) {
      return window.location.protocol + '//' + window.location.host + window.location.pathname;
    }
    return null;
  }

  /*
   * Function to get Current Site Url
   * Samples:
   *      '/sites/intranet'
   */
  public static getWebServerRelativeUrl(): string {
    if (window
      && 'location' in window
      && 'pathname' in window.location) {
      return  window.location.pathname.replace(/\/$/, '');
    }
    return null;
  }

  /*
   * Function to get Layout Page Url
   * Replacement in SPFx for SP.Utilities.Utility.getLayoutsPageUrl('sp.js')
   * Samples:
   *      getLayoutsPageUrl('sp.js')
   *      '/sites/intranet/_layouts/15/sp.js'
   */
  public static getLayoutsPageUrl(libraryName: string): string {
    if (window
      && 'location' in window
      && 'pathname' in window.location
      && libraryName !== '') {
      return  window.location.pathname.replace(/\/$/, '') + '/_layouts/15/' + libraryName;
    }
    return null;
  }

  /*
   * Function to get Current Domain Url
   * Samples:
   *      'https://domain.sharepoint.com'
   */
  public static getAbsoluteDomainUrl(): string {
      if (window
          && 'location' in window
          && 'protocol' in window.location
          && 'host' in window.location) {
          return window.location.protocol + '//' + window.location.host;
      }
      return null;
  }

  public static escapeListName(name: string): string {
    name = name.replace('\'', '\'\'');
    return encodeURIComponent(name);
  }

  public static makeAbsolute(url: string) {
    if (!url) {
      return url;
    }
    if (url.length > 0 && '/' === url.substr(0, 1)) {
      url = window.location.protocol + '//' + window.location.host + url;
    }
    return url;
  }

  public static makeRelative(url: string) {
    if (!url) {
      return url;
    }
    url = url.toLowerCase();
    if ( !url.endsWith('/')) {
      url = url + '/';
    }
    if (url.length > 0 && '/' !== url.substr(0, 1)) {
      url = '/' + url.replace(/^(?:\/\/|[^\/]+)*\//, '');
    }
    if ( url.endsWith('/')) {
      url = url.slice(0, -1);
    }
    return url === '' ? '/' : url;
  }

  public static getCurrentUrl(): Observable < string > {
    return new Observable < string > ((observer) => {
      if (_spPageContextInfo) {
        observer.next(_spPageContextInfo.webServerRelativeUrl);
        observer.complete();
      } else {
        const ctx = SP.ClientContext.get_current();
        const web = ctx.get_web();
        ctx.load(web);
        ctx.executeQueryAsync(() => {
          observer.next(web.get_serverRelativeUrl());
          observer.complete();
        }, () => {
          observer.next('');
          observer.complete();
        });
      }
    });
  }

  public static getUrlParameterByName(name, url) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) { return null; }
    if (!results[2]) { return ''; }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  public static removeSlash(url: string) {
    if (!url) {
      return url;
    }
    return url.endsWith('/') ? url.slice(0, -1) : url;
  }
}
